import thunk from "redux-thunk";
import { applyMiddleware, compose, createStore } from "redux";
import { createLogger } from "redux-logger";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from "./reducers/index";

export default () => {
  const persistConfig = {
    key: 'funblocks',
    storage: storage,
    // blacklist: ['uiState'],
    // 指定需要持久化的 reducer
    // 例如：whitelist: ['files', 'editor', 'documents']
    // 或者使用 blacklist 排除不需要持久化的
    // blacklist: ['ui', 'temp']

    // 如果你的文件列表和内容在特定的 reducer 中，取消下面的注释并修改
    // whitelist: ['markdownFiles', 'fileContent']
  };

  const persistedReducer = persistReducer(persistConfig, rootReducer);

  const middlewares = [thunk];

  // 只在开发环境使用 logger
  if (process.env.NODE_ENV !== 'production') {
    const logger = createLogger();
    middlewares.push(logger);
  }

  const preloadState = {};

  let store = createStore(
    persistedReducer,
    preloadState,
    compose(applyMiddleware(...middlewares))
  );

  let persistor = persistStore(store);

  return { store, persistor };
}